import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteShiftApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deleteShift = createAsyncThunk('deleteShift', async (payload) => {
  return await deleteShiftApi(payload);
});

const deleteShiftSlice = createSlice({
  name: 'deleteShift', // Unique Name
  initialState,
  reducers: {
    deleteShiftReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteShift.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deleteShift.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deleteShift.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deleteShiftReset } = deleteShiftSlice.actions;

export default deleteShiftSlice.reducer;
